"use client";
import { ark } from "../factory.js";
import { useFieldContext } from "./use-field-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/field/field-select.tsx
var FieldSelect = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useFieldContext()?.getSelectProps(), props);
	return /* @__PURE__ */ jsx(ark.select, {
		...mergedProps,
		ref
	});
});
FieldSelect.displayName = "FieldSelect";
//#endregion
export { FieldSelect };
